import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getClassHeatmap, getEnterpriseHeatmap, readableApiError, HEATMAP_SORTS } from '../../api/dashboard';
import { heatColor } from './_styles';
import './dashboard.css';

const SORT_OPTIONS = [
  { value: HEATMAP_SORTS.SCORE_DESC, label: '总分↓' },
  { value: HEATMAP_SORTS.SCORE_ASC,  label: '总分↑' },
  { value: HEATMAP_SORTS.NAME,       label: '姓名' },
];

// scope-aware（class | enterprise）。
export default function ClassHeatmapPage({ scope = 'class' }) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sort, setSort] = useState(HEATMAP_SORTS.SCORE_DESC);

  const isEnt = scope === 'enterprise';
  const basePath = isEnt ? `/dashboard/enterprises/${id}` : `/dashboard/classes/${id}`;

  useEffect(() => {
    setError(null);
    setLoading(true);
    (isEnt ? getEnterpriseHeatmap(id, { sort }) : getClassHeatmap(id, { sort }))
      .then((d) => { setData(d); setLoading(false); })
      .catch((err) => { setError(readableApiError(err)); setLoading(false); });
  }, [id, sort, isEnt]);

  return (
    <div className="aiq-dash dash-page">
      <div className="dash-head">
        <h1 className="dash-h1">维度强弱热力图</h1>
        <p className="dash-sub">学员 × 维度。颜色越绿分越高，越红分越低。未测维度显示「—」。</p>
      </div>

      <div className="dash-toolbar">
        <Link to={basePath} className="dash-back">← 返回总览</Link>
        <div className="dash-tabs">
          {SORT_OPTIONS.map((opt) => (
            <button key={opt.value} onClick={() => setSort(opt.value)} disabled={loading}
              className={`dash-tab${sort === opt.value ? ' is-active' : ''}`}
              style={{ cursor: loading ? 'wait' : 'pointer', border: 'none', background: sort === opt.value ? undefined : 'transparent' }}>
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      {error && <div className="dash-card dash-card--error">{error}</div>}
      {!data && !error && <div className="dash-card">加载中...</div>}
      {data && data.rows.length === 0 && (
        <div className="dash-card"><div className="dash-mut">暂无已完成测评的学员</div></div>
      )}
      {data && data.rows.length > 0 && (
        <div className="dash-card dash-card--flush dash-scroll-x" style={{ opacity: loading ? 0.55 : 1, transition: 'opacity 120ms' }}>
          <table className="dash-table" style={{ minWidth: 880 }}>
            <thead>
              <tr>
                <th>学员</th>
                <th className="dash-num-cell">总分</th>
                {data.dimensions.map((d) => (
                  <th key={d.code} title={d.name}
                      style={{
                        textAlign: 'center',
                        writingMode: 'vertical-rl', height: 120,
                        // 长维度名（如"系统性思维与战略判断能力"）超出 120px 截断
                        maxHeight: 120, overflow: 'hidden', textOverflow: 'ellipsis',
                      }}>
                    {d.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.rows.map((row) => (
                <tr key={row.student.id}>
                  <td>
                    <div style={{ fontWeight: 600 }}>{row.student.display_name || '—'}</div>
                    <div className="dash-mut">{row.student.position || ''}</div>
                  </td>
                  <td className="dash-num-cell" style={{ fontWeight: 700 }}>
                    {row.total_score ?? '—'}
                  </td>
                  {row.scores.map((s, i) => (
                    <td key={i} style={{
                      textAlign: 'center', fontWeight: 600,
                      color: s == null ? '#94a3b8' : '#fff',
                      background: s == null ? '#f1f5f9' : heatColor(s),
                    }}>
                      {s == null ? '—' : s}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
